module.exports = __webpack_public_path__ + "img/Atlanta.819b60b7.jpg";